import apiClient from 'apiClient';
import { Vulnerability } from './Vulnerability';
import { Vulnerability as DomainVulnerability } from 'modules/cm/Vulnerabilities/Vulnerability';
import { apiToDomain, domainToApi } from './mapper';
import { FormVulnerbaility } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/Vulnerabilities/Vulnerability';

const create = async (apiPrefix: string, vulnerability: FormVulnerbaility): Promise<DomainVulnerability> => {
  try {
    const { data } = await apiClient.post<Vulnerability>(`${apiPrefix}/vulnerabilities`, domainToApi(vulnerability));

    return apiToDomain(data);
  } catch (e) {
    throw new Error('Could not create vulnerability.');
  }
};

export default create;
